<div class="px-5 pb-60 max-w-screen-sm mx-auto md:max-w-full">
  @if ((ordersPageVm$ | async) ?? loadingVm; as vm) {
    <h1 class="py-6 font-accent font-bold text-2xl">
      {{ 'orders.current-orders' | translate }}
    </h1>

    @if (!vm.isActiveOrdersLoading) {
      <div class="md:grid grid-cols-2 xl:grid-cols-3 gap-6">
        @if (vm.activeOrders.length) {
          @for (order of vm.activeOrders; track order.id) {
            <div>
              <app-order-card
                [order]="order"
                (cardClick)="goToOrderDetails($event.id)"
              ></app-order-card>
            </div>
          }
        } @else {
          <div class="text-center text-neutral-500 text-sm ng-star-inserted py-2">
            {{ 'orders.no-current-orders' | translate }}
          </div>
        }
      </div>
    }

    <h1 class="py-6 font-accent font-bold text-2xl">
      {{ 'orders.old-orders' | translate }}
    </h1>

    @if (!vm.isHistoricalOrdersLoading) {
      <div class="md:grid grid-cols-2 xl:grid-cols-3 gap-6">
        @if (vm.historicalOrders.length) {
          @for (order of vm.historicalOrders; track order.id) {
            <div>
              <app-order-card
                [order]="order"
                (cardClick)="goToOrderDetails($event.id)"
              ></app-order-card>
            </div>
          }
        } @else {
          <div class="text-center text-neutral-500 text-sm ng-star-inserted py-2">
            {{ 'orders.no-old-orders' | translate }}
          </div>
        }
      </div>
    } @else {
      <div class="mb-8xs">
        @for (i of [].constructor(20); track $index) {
          <app-order-card-skeleton></app-order-card-skeleton>
        }
      </div>
    }

    @if (
      !vm.isActiveOrdersLoading &&
      !vm.isHistoricalOrdersLoading &&
      !vm.activeOrders.length &&
      !vm.historicalOrders.length
    ) {
      <div class="text-center text-neutral-500 text-sm ng-star-inserted py-10 pb-80">
        {{ 'orders.no-orders' | translate }}
      </div>
    }
  }
</div>
